import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGas: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGas"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H15V9H19V16H20V8.41421L17.5858 6L19 4.58579L22 7.58579V18H17V11H15V19H16V21H2V19H3V3ZM6 9H12V11H6V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGas;
